import { render, staticRenderFns } from "./TextConfigComponent.vue?vue&type=template&id=7d1f2b64&scoped=true&"
import script from "./TextConfigComponent.vue?vue&type=script&lang=js&"
export * from "./TextConfigComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d1f2b64",
  null
  
)

export default component.exports